import {
    ActionStatus,
    CodedProperty,
    FailureSeverity,
    NamedProperty,
    ValidationFailure,
    createFailure,
    depascalize
} from "sprint-common-web";

import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";
import { OrderRequestStatus } from "../../../../common/types/OrderRequestStatus";

export interface SendOrderRequestItem {
    id: string;
    content?: string;
    version?: string;
    contentType?: ContentReferenceType;
    pONumber: string;
    airline?: CodedProperty;
    system?: NamedProperty;
    status: OrderRequestStatus;
    isTrailer?: boolean;
}

export type ProcessSendOrderRequestItem = SendOrderRequestItem & {
    processStatus: ActionStatus;
};

const orderPendingStr = depascalize(OrderRequestStatus[OrderRequestStatus.Pending]);
const discardedOrdersInfoMessage = `Order requests with status other than '${orderPendingStr}' have been discarded`;

export const validateDiscardedItems = (
    items: SendOrderRequestItem[],
    selectedItemsCount: number
): ValidationFailure | void => {
    if (!items.length) {
        return createFailure(
            `${discardedOrdersInfoMessage}. Nothing to send.`,
            "no-order-requests-to-deliver",
            FailureSeverity.Error
        );
    } else if (items.length < selectedItemsCount) {
        return createFailure(discardedOrdersInfoMessage, "order-requests-discarded-from-sent", FailureSeverity.Warning);
    }
};
